import type { ReactNode } from 'react'

import type { CSSProperties } from 'styled-components'

import { Container } from './Container'

type Props = {
	children: ReactNode
	style?: CSSProperties
	className?: string
}

export const Card = ({ children, style, className }: Props) => (
	<Container style={style} className={className}>
		{children}
	</Container>
)
